import type { Save } from './save/schema';

/**
 * Story beats kept in the save's `seen` list, and what reaching them changes. Plain functions on a
 * save draft, so the scenes only decide when, not how.
 */

export const SEEN = {
  /** The Earth tutorial, played before the very first launch. */
  tutorial: 'tutorial',
  /** The Ranger's memory log (Dad is alive): changes what the suit says in the lab. */
  rangerLog: 'ranger-log',
  /** The suit's word the first time it stands in radiation it isn't shielded for. */
  radiation: 'radiation',
  /** ... the first time it fits a weapon mod, and the first time it has no slot for one. */
  modFitted: 'mod-fitted',
  modNoSlot: 'mod-no-slot',
} as const;

type Draft = Pick<Save, 'seen' | 'upgrades'>;

/** The first launch goes through the Earth tutorial. */
export function needsTutorial(save: Pick<Save, 'seen'>): boolean {
  return !save.seen.includes(SEEN.tutorial);
}

/**
 * Finishing the tutorial gives the Heat Shield: the first Shielding level, needed to leave Earth's
 * atmosphere (GDD: Upgrades). Never lowers a level the save already has.
 */
export function finishTutorial(draft: Draft): void {
  see(draft, SEEN.tutorial);
  draft.upgrades.shielding = Math.max(1, draft.upgrades.shielding);
}

export function readRangerLog(draft: Draft): void {
  see(draft, SEEN.rangerLog);
}

/** The beat for landing on a planet the first time (the suit says what is new there). */
export function landedOn(planetId: string): string {
  return `landed-${planetId}`;
}

/** Marks a beat seen; true if it is new (so it plays once). */
export function see(draft: Pick<Save, 'seen'>, beat: string): boolean {
  if (draft.seen.includes(beat)) return false;
  draft.seen.push(beat);
  return true;
}
